// removed by extract-text-webpack-plugin
module.exports = {"colorIcon":"_227c_ Md4ty","emojiIcon":"_3_irg _3MLH0","icon":"_3B0fO _2M9f_"};


//////////////////
// WEBPACK FOOTER
// ./components/LabelIcon.css
// module id = 2017
// module chunks = 3